// Internal Imports
import * as AgGrid from "../../mashupV2";
import { API_ENDPOINTS, GRID } from "../../constants";
import { get, put, post } from "../../api/index";
import { GlobalUtils } from "../../utils";
import store from "../../store";

// Destructuring
const { readDataFromLocalStorage } = GlobalUtils;
const { APIS } = API_ENDPOINTS;
const { GRID_PAGE_TYPE } = GRID;

export const getPriceListsService = () =>
  new Promise((resolve, reject) => {
    get(APIS.PRICE_LISTS)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const addPricebookService = payload =>
  new Promise((resolve, reject) => {
    post(APIS.PRICE_LISTS, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updatePricebookInfoService = payload =>
  new Promise((resolve, reject) => {
    put(`${APIS.PRICE_LISTS}/${payload.id}`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getViewConfig = async (priceListId, currencySymbol) => {
  const getAppView = readDataFromLocalStorage("appView");
  const { PricelistItemsView } =
    getAppView && getAppView.views ? getAppView.views : {};
  const gridConfig = await get(`${APIS.VIEW_METADATA}/${PricelistItemsView}`)
    .then(res => {
      const data = AgGrid.formatColumnData(
        res,
        GRID_PAGE_TYPE.PRICELIST,
        currencySymbol,
      );
      // Additional Data to be stored inside metaData
      data.metaData.pricelistId = priceListId;
      return data;
    })
    .catch(error => {
      throw error;
    });
  return gridConfig;
};

export const getPricebookViewConfig = async (priceListId, currencySymbol) => {
  const getAppView = readDataFromLocalStorage("appView");
  const { PricelistItemsView } =
    getAppView && getAppView.views ? getAppView.views : {};
  const gridConfig = await get(`${APIS.VIEW_METADATA}/${PricelistItemsView}`)
    .then(res => {
      const data = AgGrid.formatColumnData(
        res,
        GRID_PAGE_TYPE.PRICELIST,
        currencySymbol,
      );
      // Additional Data to be stored inside metaData
      data.metaData.pricelistId = priceListId;
      return data;
    })
    .catch(error => {
      throw error;
    });
  return gridConfig;
};

export const getproductViewConfig = async (priceListId, currencySymbol) => {
  const gridConfig = await get(`${APIS.VIEW_METADATA}/${priceListId}`)
    .then(res => {
      const data = AgGrid.formatColumnData(
        res,
        GRID_PAGE_TYPE.PRODUCTS,
        currencySymbol,
      );
      // Additional Data to be stored inside metaData
      data.metaData.pricelistId = priceListId;
      return data;
    })
    .catch(error => {
      throw error;
    });
  return gridConfig;
};

export const getDealTableColumns = async () => {
  const getAppView = readDataFromLocalStorage("appView");
  const { DealTableView } =
    getAppView && getAppView.views ? getAppView.views : {};
  const columnData = await get(`${APIS.VIEW_METADATA}/${DealTableView}`)
    .then(res => {
      const data = res.VIW.columns.find(item => item.name === "quantity");
      return data;
    })
    .catch(error => {
      throw error;
    });
  console.debug(columnData);
  return columnData;
};

export const getPriceListRowData = async (priceListId, metaData) => {
  const rowData = await get(
    `${APIS.CHILD_VIEWS}/${priceListId}/${metaData.tblViewId}`,
  )
    .then(res => {
      const parsedData = AgGrid.formatRowData(res.ViewData.rowData, metaData);
      return parsedData;
    })
    .catch(error => {
      throw error.response;
    });
  return rowData;
};

export const getProducts = async () => {
  const products = await get(`${APIS.PRODUCTS}?deep_fetch=false`)
    .then(res => res.Products)
    .catch(error => {
      throw error;
    });
  return products;
};

export const getUnusedProductsService = plistID =>
  new Promise((resolve, reject) => {
    get(`${APIS.UNUSED_PRODUCTS}/pricelists/${plistID}`)
      .then(res => {
        resolve(res.Products);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updatePricebookDataService = async obj => {
  const { masterTblID, pricelistId, tableId, tblViewId } =
    store.getState().PricebookStore.metaData;
  return new Promise((resolve, reject) => {
    put(
      `${APIS.TABLES}/${masterTblID}/${pricelistId}/${tableId}?view_id=${tblViewId}`,
      [obj],
    )
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const addColumnService = async payload => {
  const { tblViewId } = store.getState().PricebookStore.metaData;
  const products = await post(
    `${APIS.VIEW_METADATA}/${tblViewId}/addcolumn`,
    payload,
  )
    .then(res => res)
    .catch(error => {
      throw error;
    });
  return products;
};

export const searchProfessionalServices = (pricelistId, searchTxt) =>
  new Promise((resolve, reject) => {
    get(`${APIS.CATALOGS}/${pricelistId}/services?text=${searchTxt}`)
      .then(res => {
        resolve(res.PriceListItems);
      })
      .catch(error => {
        reject(error);
      });
  });

export const searchProductForPOT = (pricelistId, searchTxt) =>
  new Promise((resolve, reject) => {
    get(`${APIS.PRICE_LISTS}/${pricelistId}/items/search?text=${searchTxt}`)
      .then(res => {
        resolve(res.priceListItems);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getAllClauses = () =>
  new Promise((resolve, reject) => {
    get(APIS.CLAUSES)
      .then(res => {
        const tempClauses = res.Clauses.map(clause => {
          const newObj = {};
          newObj.id = clause.id;
          newObj.name = clause.name;
          return newObj;
        });
        resolve(tempClauses);
      })
      .catch(err => {
        reject(err);
      });
  });

export const addProductColumnService = async (payload, pageView) => {
  // const getAppView = readDataFromLocalStorage("appView");
  // const { ProductsView } =
  //   getAppView && getAppView.views ? getAppView.views : {};
  const products = await post(
    `${APIS.VIEW_METADATA}/${pageView}/addcolumn`,
    payload,
  )
    .then(res => res)
    .catch(error => {
      throw error;
    });
  return products;
};

export const editProductColumnService = async (
  payload,
  columnId,
  ProductsView,
) => {
  // const getAppView = readDataFromLocalStorage("appView");
  // const { ProductsView } =
  //   getAppView && getAppView.views ? getAppView.views : {};
  const products = await put(
    `${APIS.VIEW_METADATA}/${ProductsView}/columns/${columnId}`,
    payload,
  )
    .then(res => res)
    .catch(error => {
      throw error;
    });
  return products;
};
export const updateCrossviewOptionService = (payload, ProductsView) =>
  new Promise((resolve, reject) => {
    post(`${APIS.VIEW_METADATA}/${ProductsView}/crossview/addcolumn`, payload)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const getcrossViewOptionservice = (columnId, view) =>
  new Promise((resolve, reject) => {
    get(`${APIS.VIEW_METADATA}/${view}/crossview/columns/${columnId}`)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
